const LOCK_CLASS = 'sz-mobile-sidebar-open';
const BODY_PROPERTIES = ['position', 'top', 'left', 'right', 'width', 'overflow', 'overflow-x', 'overflow-y'];

const captureStyle = (style, property) => ({ value: style.getPropertyValue(property), priority: style.getPropertyPriority(property) });
const restoreStyle = (style, property, saved) => {
    if (saved.value) style.setProperty(property, saved.value, saved.priority);
    else style.removeProperty(property);
};

// Observe the existing drawer class, including closes performed by page clicks/actions.
// Fixing the body also prevents background scrolling on mobile Safari; the sidebar
// remains its own native scroll container, without cancelling touch/pinch events.
export const createMobileSidebarScrollLock = () => {
    let locked = null;
    let disposed = false;
    const body = document.body;
    const root = document.documentElement;

    const unlock = ({ restorePosition = true } = {}) => {
        if (!locked) return;
        const saved = locked;
        locked = null;
        for (const property of BODY_PROPERTIES) restoreStyle(body.style, property, saved.styles[property]);
        root.classList.remove(LOCK_CLASS);
        if (restorePosition && (window.scrollX !== saved.x || window.scrollY !== saved.y)) {
            const behavior = captureStyle(root.style, 'scroll-behavior');
            root.style.setProperty('scroll-behavior', 'auto', 'important');
            window.scrollTo(saved.x, saved.y);
            restoreStyle(root.style, 'scroll-behavior', behavior);
        }
    };

    const sync = (options = {}) => {
        if (disposed) return;
        if (window.innerWidth > 1200 || !body.classList.contains('offcanvas-active')) {
            unlock(options);
            return;
        }
        if (locked) return;
        locked = { x: window.scrollX || 0, y: window.scrollY || 0,
            styles: Object.fromEntries(BODY_PROPERTIES.map(property => [property, captureStyle(body.style, property)])) };
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', `-${locked.y}px`);
        body.style.setProperty('left', `-${locked.x}px`);
        body.style.setProperty('right', '0');
        body.style.setProperty('width', '100%');
        body.style.setProperty('overflow', 'hidden');
        root.classList.add(LOCK_CLASS);
    };

    const observer = new MutationObserver(() => sync());
    observer.observe(body, { attributes: true, attributeFilter: ['class'] });
    const onResize = () => sync();
    window.addEventListener('resize', onResize);
    sync();
    return {
        sync,
        dispose: (options = {}) => {
            observer.disconnect();
            window.removeEventListener('resize', onResize);
            unlock(options);
            disposed = true;
        },
    };
};
